(() => {
  const body = document.body;
  const main = document.getElementById('mm-main');
  if (main) main.tabIndex = -1;
  document.querySelectorAll('.mm-skip').forEach(link => link.addEventListener('click', () => {
    if (main) main.focus({preventScroll: true});
  }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('.mm-filter[open],.mmp-option-dropdown[open]');
    if (disclosure) {
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
      event.preventDefault();
    }
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.mm-menu[open],.mm-filter[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mm-filter[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
    const toggle = event.target.closest('[data-mm-recovery]');
    if (toggle) {
      const recover = document.getElementById('recover_password');
      const login = document.getElementById('customer_login');
      const opening = toggle.dataset.mmRecovery === 'open';
      recover.hidden = !opening;
      login.hidden = opening;
      const target = opening ? recover.querySelector('h2') : login.querySelector('[data-mm-recovery]');
      target?.focus();
    }
  });
  function setupForm(form) {
    if (form.dataset.mmValidationReady) return;
    form.dataset.mmValidationReady = 'true';
    form.noValidate = true;
    let attempted = false;
    let summary = form.querySelector('[data-mm-form-errors]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'mm-form-errors';
      summary.dataset.mmFormErrors = '';
      summary.tabIndex = -1;
      summary.hidden = true;
      form.prepend(summary);
    }
    const fields = () => [...form.elements].filter(field => field.willValidate);
    function clear(field) {
      const errorId = field.dataset.mmErrorId;
      if (!errorId) return;
      document.getElementById(errorId)?.remove();
      const descriptions = (field.getAttribute('aria-describedby') || '').split(' ').filter(id => id && id !== errorId);
      if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '));
      else field.removeAttribute('aria-describedby');
      field.removeAttribute('aria-invalid');
      delete field.dataset.mmErrorId;
    }
    function validate(focus) {
      fields().forEach(clear);
      const invalid = fields().filter(field => !field.validity.valid);
      summary.replaceChildren();
      summary.hidden = !invalid.length;
      if (!invalid.length) return true;
      const title = document.createElement('p');
      title.textContent = body.dataset.formErrorTitle;
      const list = document.createElement('ul');
      summary.append(title, list);
      invalid.forEach((field, index) => {
        if (!field.id) field.id = `${form.id || 'mm-form'}-field-${index}`;
        const errorId = `${field.id}-error`;
        const message = field.validationMessage;
        const label = field.getAttribute('aria-label') || [...(field.labels || [])].map(item => item.textContent.trim()).join(' ') || field.name;
        const error = document.createElement('span');
        error.id = errorId;
        error.className = 'mm-field-error';
        error.textContent = message;
        field.insertAdjacentElement('afterend', error);
        field.setAttribute('aria-invalid', 'true');
        const descriptions = (field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
        field.setAttribute('aria-describedby', [...descriptions, errorId].join(' '));
        field.dataset.mmErrorId = errorId;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${field.id}`;
        link.textContent = `${label}: ${message}`;
        link.addEventListener('click', event => {event.preventDefault(); field.focus();});
        item.append(link);
        list.append(item);
      });
      if (focus) summary.focus();
      return false;
    }
    form.addEventListener('submit', event => {
      if (event.submitter?.formNoValidate) return;
      attempted = true;
      if (!validate(true)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    form.addEventListener('input', event => {
      if (attempted && event.target.validity?.valid) validate(false);
    });
  }
  function setupForms() {
    document.querySelectorAll('form[data-mm-validate]').forEach(setupForm);
  }
  setupForms();
  document.addEventListener('meme:form-ready', setupForms);
  const recovery = document.getElementById('recover_password');
  if (recovery?.querySelector('[data-mm-server-errors],[data-mm-form-success]')) {
    recovery.hidden = false;
    document.getElementById('customer_login').hidden = true;
  }
  const serverError = [...document.querySelectorAll('[data-mm-server-errors]')].find(error => error.getClientRects().length);
  if (serverError) {
    const form = serverError.closest('form');
    serverError.id ||= `${form?.id || 'mm-form'}-server-errors`;
    serverError.querySelectorAll('[data-error-field]').forEach(item => {
      const field = [...(form?.elements || [])].find(input => input.name === item.dataset.errorField || input.name.endsWith(`[${item.dataset.errorField}]`));
      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), serverError.id].filter(Boolean).join(' '));
      }
    });
    serverError.focus();
  }
  const success = document.querySelector('[data-mm-form-success]');
  if (success) success.focus();
  if (location.hash === '#recover') document.querySelector('[data-mm-recovery="open"]')?.click();
})();
